export default __webpack_public_path__ + "static/cap5-64b82149104debfb48046ac43cc10ee6.png";